import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AccessFormPopupStatus = "Closed" | "Signup" | "Login";

export interface AccessFormPopupState {
  status: AccessFormPopupStatus;
  /** #693: set when this session just completed an extension signup; consumed by the welcome flow. */
  justSignedUp: boolean;
}

const initialState: AccessFormPopupState = {
  status: "Closed",
  justSignedUp: false,
};

const AccessFormPopupSlice = createSlice({
  name: "AccessFormPopupSlice",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<AccessFormPopupStatus>) => {
      state.status = action.payload;
    },
    markSignedUp: (state) => {
      state.justSignedUp = true;
    },
    clearSignedUp: (state) => {
      state.justSignedUp = false;
    },
  },
});

export const accessFormPopupActions = AccessFormPopupSlice.actions;
export default AccessFormPopupSlice.reducer;
